import React from 'react';
import PropTypes from 'prop-types';


const AlertMessages = () => (
    <div className="AlertMessages" hidden>
        <div className="alert alert-success" role="alert" >
            Direct email has been added successfully to [Name].
        </div>
        <div className="alert alert-danger" role="alert" >
            You forgot to enter a name for your direct email.
        </div>
        <div className="alert alert-danger" role="alert" >
            The email name you entered is already being used. Please enter a different name.
        </div>
        <div className="alert alert-danger" role="alert" >
            Something went wrong while adding your new email. Please double check to make sure there are no white spaces or commas. If the problem persists please contact your administrator.
        </div>
  </div>
);
export default AlertMessages;
